import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { setDrawerFilter } from '../actions/drawer';
export default handleActions({
    [`${setDrawerFilter}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            activeFilter: action.payload.filter
        })
}, {
    activeFilter: 'all'
});

//# sourceMappingURL=drawer.js.map